module.exports = __webpack_public_path__ + "static/media/IoT-屏幕-新.38851979.jpg";